import gql from 'graphql-tag';

export default gql`
  query getSocialSellerInfo($sellerId: String!, $cjEvent:String){
    getSocialSellerInfo(sellerId: $sellerId, cjEvent: $cjEvent) {
      sellerInfo {
        sellerId
        sellerName
        sellerImage
      }
    }
}
`;
